import { styled } from '@mui/material'
import { Rating } from 'react-simple-star-rating'

export const RatingStyled = styled(Rating)(props => `
  > span:first-of-type {
    display: flex;
    align-items: center;
  }
`)
